import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Modal, Header, List, Icon, Checkbox} from 'semantic-ui-react';
import Button from 'semantic-ui-react/dist/commonjs/elements/Button/Button';
import Input from 'semantic-ui-react/dist/commonjs/elements/Input/Input';
import moment from 'moment-timezone';

class ViewUserAccountResult extends Component {
    constructor(props){
        super(props);
        this.state = {policyNumber: '', showEmail: false, email: '', showDelete: false};
        this.onDeletePolicy = this.onDeletePolicy.bind(this);
        this.onAddPolicy = this.onAddPolicy.bind(this);
        this.onPolicyNumberChange = this.onPolicyNumberChange.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onPasswordReset = this.onPasswordReset.bind(this);
        this.onShowChangeEmail = this.onShowChangeEmail.bind(this);
        this.onHideChangeEmail = this.onHideChangeEmail.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onChangeEmailClick = this.onChangeEmailClick.bind(this);
        this.onShowDeleteAccount = this.onShowDeleteAccount.bind(this);
        this.onCancelDelete = this.onCancelDelete.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onSendConfirmation = this.onSendConfirmation.bind(this);
    }
    
    onDeletePolicy(e, {data}){
        const deletePolicy = this.props.onDeletePolicy;
        const {id, userId} = data;
        deletePolicy({userId, id});
    }
    onAddPolicy(e){
        const {policyNumber} = this.state;
        const {id} = this.props.user;
        const addPolicy = this.props.onAddPolicy;
        if (policyNumber.length > 3){
            addPolicy({userId: id, policyNumber});
            this.setState({policyNumber: ''});
        }
    }
    onPolicyNumberChange(e, {value}){
        this.setState({policyNumber: value});
    }
    onEmailChange(e, {value}){
        this.setState({email: value});
    }
    onClose(e){
        this.setState({policyNumber: '', showEmail: false, email: ''});
        this.props.onClose();
    }
    onPasswordReset(e){
        const {user} = this.props;
        const resetPassword = this.props.onPasswordReset;
        resetPassword(user.id);
    }
    onSendConfirmation(e){
        const {user} = this.props;
        const sendConfirmation = this.props.onSendConfirmation;
        sendConfirmation(user.id);
    }
    onShowChangeEmail(e){
        const {user} = this.props;
        this.setState({showEmail: true, email: user.email});
    }
    onHideChangeEmail(e){
        this.setState({showEmail: false});
    }
    async onChangeEmailClick(e){
        const changEmail = this.props.onChangeEmail;
        const {user} = this.props;
        const {email} = this.state;
        await changEmail({userId: user.id, oldEmail: user.email, newEmail: email});
        this.onHideChangeEmail(e);
    }
    onShowDeleteAccount(e){
        this.setState({showDelete: true});
    }
    onDelete(e){
        const deleteUser = this.props.onDeleteUser;
        const {user} = this.props;
        deleteUser({userId: user.id});
        this.setState({showDelete: false});
    }
    onCancelDelete(e){
        this.setState({showDelete: false});
    }
    render() {
        const {open, user} = this.props;
        const { policyNumber, showEmail, email, showDelete } = this.state;
        return (
            <div>
            <Modal size="tiny" open={showDelete}>
                <Modal.Header content={`Delete ${user.name}`}/>
                <Modal.Content content="Are you sure you want to delete this account?" />
                <Modal.Actions>
                    <Button negative content="Delete" onClick={this.onDelete} />
                    <Button positive content="Cancel" onClick={this.onCancelDelete} />
                </Modal.Actions>
            </Modal>
            <Modal size="tiny" open={showEmail} className="admin changeEmail">
                <Modal.Header>Change Email Address</Modal.Header>
                <Modal.Content>
                    <Input placeholder="New Email Address" value={email} onChange={this.onEmailChange} />
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={this.onHideChangeEmail} />
                    <Button negative content="Change Email" onClick={this.onChangeEmailClick} disabled={user.email === email || email.length === 0 || !(email.includes("@") && email.includes(".")) } />
                </Modal.Actions>
            </Modal>
            <Modal open={open} className="admin userAccount">
                <Modal.Header>{user.name} ({user.email})</Modal.Header>
                <Modal.Content>
                    <div className="row">
                        <div className="user">
                            <div style={{display: 'flex', flexDirection: 'column', margin: '0 40px'}}>
                                <div style={{display: 'flex', flex: '1 1 auto'}}>
                                    <div style={{ flex: '1 1 0%'}}>E-Delivery:</div>
                                    <div style={{ flex: '1 1 0%'}}>Email</div>
                                    <div style={{ flex: '1 1 0%'}}>SMS</div>
                                </div>
                                <div style={{ display: 'flex', flex: '1 1 auto'}}>
                                    <div style={{ flex: '1 1 0%'}}>Billing:</div>
                                    <div style={{ flex: '1 1 0%'}}><Icon circular inverted size="small" name={user.isDeliveryViaEmail ? "check" : "delete"} color={user.isDeliveryViaEmail ? "green" : "red"} /></div>
                                    <div style={{ flex: '1 1 0%'}}><Icon circular inverted size="small" name={user.isDeliveryViaText ? "check" : "delete"} color={user.isDeliveryViaText ? "green" : "red"} /></div>
                                </div>
                                <div style={{ display: 'flex', flex: '1 1 auto'}}>
                                    <div style={{ flex: '1 1 0%'}}>Claims:</div>
                                    <div style={{ flex: '1 1 0%'}}><Icon circular inverted size="small" name={user.isClaimDeliveryViaEmail ? "check" : "delete"} color={user.isClaimDeliveryViaEmail ? "green" : "red"} /></div>
                                    <div style={{ flex: '1 1 0%'}}><Icon circular inverted size="small" name={user.isClaimDeliveryViaText ? "check" : "delete"} color={user.isClaimDeliveryViaText ? "green" : "red"} /></div>
                                </div>
                            </div>
                            {user.deliveryEnabled && <Header as="h4" content={`Delivery Enabled: ${moment.utc(user.deliveryEnabled).tz('US/Eastern').format('LLLL')}`} />}
                            {user.emailConfirmed ? <div style={{textAlign: 'center', padding: '5px 0', margin: '5px 0'}}>
                                <Icon circular inverted size="small" name="check" color="green" />Email Confirmed
                            </div> : <Button content="Send Confirmation Email" onClick={this.onSendConfirmation} />}
                            <Button content="Change Email" onClick={this.onShowChangeEmail} />
                            <Button content="Send Password Reset Email" onClick={this.onPasswordReset} />
                                <Header as="h4" content={`Last Login: ${moment.utc(user.lastLogin).tz('US/Eastern').format('LLLL')}`} /> 
                            <Checkbox toggle label="Is E-Delivery Tester" onChange={this.props.onDeliveryTester} checked={user.isDeliveryTester} data={user} />
                        </div>
                        <div className="policies">
                            <Header as="h5">Policies</Header>
                            <List>
                                {user && user.policies ? user.policies.map((policy, key) => <List.Item key={key}><Button icon="delete" negative compact data={policy} onClick={this.onDeletePolicy} /><span title={`Added On: ${moment.utc(policy.addedOn).tz('US/Eastern').format('LLLL')}`}>{policy.policyNumber}</span></List.Item>) : null}
                                <List.Item>
                                    <Input placeholder="Policy Number" value={policyNumber} onChange={this.onPolicyNumberChange} /> <Button positive disabled={policyNumber.length < 4} icon="add" onClick={this.onAddPolicy} />
                                </List.Item>
                            </List>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                        <Button negative content="Delete Account" onClick={this.onShowDeleteAccount} />
                        <Button content="Close" onClick={this.onClose} />
                </Modal.Actions>
            </Modal>
            </div>
        );
    }
}

ViewUserAccountResult.propTypes = {
    open: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    onDeletePolicy: PropTypes.func.isRequired,
    onAddPolicy: PropTypes.func.isRequired,
    onPasswordReset: PropTypes.func.isRequired,
    onSendConfirmation: PropTypes.func.isRequired,
    onChangeEmail: PropTypes.func.isRequired,
    onDeleteUser: PropTypes.func.isRequired,
    onDeliveryTester: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ViewUserAccountResult;